<template>
    <div>
        <h4 class="text-center mb-4">ΕΠΙΛΟΓΗ ΦΟΡΕΑ</h4>
        <div class="row mb-5">
            <div class="col-md-12 text-center">
                <DxButton text="Προσθήκη φορέα" type="success" icon="plus" styling-mode="contained"
                    style="margin: 1px" @click="trigger.SearchIndividual = true"/>
                <DxButton text="Αφαίρεση Όλων" type="danger" icon="clearformat" styling-mode="contained"
                    style="margin: 1px" hint="Καθαρισμός Κριτηρίων" @click="onClickDeSelect"/>
            </div>
        </div>
        <div class="row mb-3">
                <div class="col-md-3">
                    Περιφέρεια
                    <DxSelectBox
                    :search-enabled="true"
                    :data-source="regions"
                    search-mode="contains"
                    :search-timeout="200"
                    :min-search-length="2"
                    :show-data-before-search="true"
                    display-expr="Description"
                    value-expr="Id"
                    v-model="selectedRegionId"
                    @value-changed="setSelectedRegion"
                    placeholder="Επιλέξτε Περιφέρεια"
                    :show-clear-button="true"
                    />
                </div>
                <div class="col-md-3">
                    Νομός
                    <DxSelectBox
                    :search-enabled="true"
                    :data-source="counties"
                    search-mode="contains"
                    :search-timeout="200"
                    :min-search-length="2"
                    :show-data-before-search="true"
                    display-expr="Description"
                    value-expr="Id"
                    v-model="selectedCountyId"
                    @value-changed="setSelectedCounty"
                    placeholder="Επιλέξτε Νομό"
                    :show-clear-button="true"
                    />
                </div>
                <div class="col-md-3">
                    Δήμος
                    <DxSelectBox
                    :search-enabled="true"
                    :data-source="municipalities"
                    search-mode="contains"
                    :search-timeout="200"
                    :min-search-length="2"
                    :show-data-before-search="true"
                    display-expr="Description"
                    value-expr="Id"
                    v-model="selectedMunicipalityId"
                    @value-changed="setSelectedMunicipality"
                    placeholder="Επιλέξτε Δήμο"
                    :show-clear-button="true"
                    />
                </div>
                <div class="col-md-3">
                    <br />
                    <DxButton text="Προσθήκη Επίλεγμένων" type="success" icon="plus"
                    hint="Ανάθεση οργανισμών" @click="onClickSelect" />
                </div>
            </div>
        <SearchOrganization :organizations="organizations" :trigger="trigger" />
    </div>
</template>
<script>
import mainService from "../../../services/mainService";
import { DxButton } from "devextreme-vue/button";
import { DxSelectBox } from "devextreme-vue/select-box";
import SearchOrganization from "./SearchOrganization.vue";

export default {
    props:['organizations'],
    components:{
        DxButton,
        DxSelectBox,
        SearchOrganization
    },
    data() {
        return{
            regions:[],
            counties:[],
            municipalities:[],
            selectedRegionId: 0,
            selectedCountyId: 0,
            selectedMunicipalityId: 0,
            trigger: {
                SearchIndividual: false
            }
        }
    },
    async mounted(){
        var regions = await mainService.get(`/Regions/GetRegions`);
        this.regions = regions.data
    },
    methods:{
        onClickSelect(){
            if(this.selectedRegionId == 0 && this.selectedMunicipalityId == 0 && this.selectedCountyId == 0)
                this.organizations.map(x=>x.Send = true)

            this.organizations
            .filter(x=>x.RegionId == (this.selectedRegionId > 0 ? this.selectedRegionId : x.RegionId))
            .filter(x=>x.MunicipalityId == (this.selectedMunicipalityId > 0 ? this.selectedMunicipalityId : x.MunicipalityId))
            .filter(x=>x.CountyId == (this.selectedCountyId > 0 ? this.selectedCountyId : x.CountyId))
            .map(x=>x.Send = true);

        },
        onClickDeSelect(){
            this.organizations.map(x=>x.Send = false)
        },
        async setSelectedRegion(e) {
            this.clearCounties();
            this.clearMunicipalities();

            if (e.value != null) {
                this.selectedRegionId = e.value;
                const _res = await mainService.get(
                `/Counties/GetCountiesByRegionId?regionid=${e.value}`
                );
                this.counties = _res.data;
            } else {
                this.selectedRegionId = 0;
            }
        },
        clearCounties() {
            this.counties = [];
            this.selectedCountyId = 0;
        },
        clearMunicipalities() {
            this.municipalities = [];
            this.selectedMunicipalityId = 0;
        },
        async setSelectedCounty(e) {
            this.clearMunicipalities();

            if (e.value != null) {
                this.selectedCountyId = e.value;
                const municipalities = await mainService.get(
                `/Municipalities/GetMunicipalitiesByCountyId?countyId=${e.value}`
                );
                this.municipalities = municipalities.data;
            } else {
                this.selectedCountyId = 0;
            }
        },
        async setSelectedMunicipality(e) {
            if (e.value != null) {
                this.selectedMunicipalityId = e.value;
            } else {
                this.selectedMunicipalityId = 0;
            }
        },
    }
}
</script>